import { Component, OnInit } from '@angular/core';
import { GoogleAnalyticsService } from 'ngx-google-analytics';
import { Title } from '@angular/platform-browser';
import {AboutUsService} from "../core/about-us.service";
import {Person} from "../shared/types/types";

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss']
})
export class ContactComponent implements OnInit {
  doctors: Person[] = [];
  masseurs: Person[] = [];
  yogas: Person[] = [];

  constructor(private gaService: GoogleAnalyticsService, private titleService: Title, private aboutUsService: AboutUsService) { }

  async ngOnInit() {
    this.titleService.setTitle('EREF fizioterápia - Kapcsolat');
    // this.gaService.pageView('/kapcsolat', 'Kapcsolat');

    const personList = await this.aboutUsService.getAboutUsFromContentful();
    this.doctors = personList.filter(person => person.job === 'gyógytornász');
    this.masseurs = personList.filter(person => person.job === 'masszőr');
    this.yogas = personList.filter(person => person.job === 'jógaoktató');

  }

}
